jQuery(document).ready(function($) {
	// Create an Alphabetical jump list
	// Look at h3 tags in the list
    var listItems;

	if ($(".cryptocurrency-list").length) {
		listItems = $(".cryptocurrency-list .all-items-list-row h3").sort();
	} else if ($(".games-list ").length) {
		listItems = $(".games-list .all-items-list-row h3").sort();
	} else if ($(".esports-list ").length) {
		listItems = $(".esports-list .all-items-list-row h3").sort();
	}
	else return;

	var letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

	var glossaryHTML = "";
	for (var i = 0; i < letters.length; i++) {
		var thisLetter = letters.charAt(i);

		// Need to find first of each letter
		var foundOne = -999;
		for (var j = 0; j < listItems.length; j++) {
			var itemText = listItems[j].innerText.toUpperCase();

			if ((i == 0) && (!isNaN(itemText.charAt(0)))) {
				foundOne = j;
				break;
			}

			if (itemText.charAt(0) == thisLetter) {
				foundOne = j;
				break;
			}
		}

		// Create links and anchors based on whether something was found
		if (foundOne == -999) {
			// letter not found
			glossaryHTML +=
				'<li class="disabled page-item"><a class="page-link">' +
				thisLetter +
				"</a></li>";
		} else {
			// We found an item with a letter
			glossaryHTML +=
				'<li class="page-item"><a class="page-link" href="#glossary-' +
				thisLetter +
				'">' +
				thisLetter +
				"</a></li>";
			// Create an anchor for the first letter found
			$(listItems[foundOne]).closest('.item-wrapper').attr("id", "glossary-" + thisLetter);
		}
	}
	// after the pagination html is built insert it to the page
	$(".all-items-alphabet-nav").html(
		"<nav aria-label='Alphabetical Navigation'><ul class='pagination'>" +
			glossaryHTML +
			"</ul></nav>"
	);
});



// WEBPACK FOOTER //
// ./scripts/autoload/alphabettical-nav.js